import { useCallback, useImperativeHandle, useState } from "react";
import { Button, DatePicker, Space } from "antd";
import Icon, { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { FaSearch } from 'react-icons/fa';
import dayjs from "dayjs";

interface IProps {
    dataIndex: any;
    ref?: any;
    onFilterClear?: (dataIndex: string) => void;
    initialValue?: string | null;
}

const IconSearch = (props: any) => <Icon {...props} component={FaSearch} />;

export const useGetColumnSearchPropsData = ({
    dataIndex,
    ref,
    onFilterClear,
    initialValue
}: IProps) => {

    const [searchText, setSearchText] = useState(initialValue ?? "");
    const [searchedColumn, setSearchedColumn] = useState(initialValue ? dataIndex : "");

    const handleSearch = useCallback((selectedKeys: any, dataIndex: any): void => {
        setSearchText(selectedKeys[0] ?? "");
        setSearchedColumn(dataIndex);
    }, []);

    const handleReset = useCallback((): void => {
        setSearchText("");
        setSearchedColumn("");
        onFilterClear?.(dataIndex);
    }, [onFilterClear, dataIndex]);

    useImperativeHandle(ref, () => ({
        limparFiltros() {
            handleReset();
        }
    }));

    let searchInput: any = '';

    return ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => {

            if (initialValue && selectedKeys.length === 0) {
                setSelectedKeys([initialValue]);
            }


            return (
                <div style={{ padding: 8 }}>

                    <DatePicker
                        ref={(node: any) => {
                            searchInput = node?.input || node;
                        }}
                        format="DD/MM/YYYY"
                        style={{ width: 180, display: "block", marginBottom: 8 }}
                        value={
                            selectedKeys[0]
                                ? dayjs(selectedKeys[0], "DD/MM/YYYY")
                                : null
                        }
                        onChange={(date, dateString) => {
                            setSelectedKeys(dateString ? [dateString] : []);
                        }}
                        placeholder="Selecione a data"
                    />

                    <Space>
                        <Button
                            type="primary"
                            onClick={() => {
                                confirm();
                                handleSearch(selectedKeys, dataIndex);
                            }}
                            icon={<SearchOutlined />}
                            size="small"
                        >
                            Buscar
                        </Button>

                        <Button
                            onClick={() => {
                                setSelectedKeys([]);
                                handleReset();
                                confirm({ closeDropdown: false });
                            }}
                            size="small"
                        >
                            Limpar
                        </Button>
                    </Space>
                </div>
            );
        },

        filterIcon: (filtered: any) =>
            filtered || initialValue
                ? <IconSearch style={{ color: '#1890ff', fontSize: 14 }} />
                : <SearchOutlined />,


        onFilterDropdownOpenChange: (visible: any) => {
            if (visible) {
                setTimeout(() => searchInput?.focus?.() || searchInput?.select?.(), 100);
            }
        },

        filteredValue: searchText ? [searchText] : null,

        render: (text: any) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });
};
